// extracted by mini-css-extract-plugin
export var borderRadius = "_5q-4";
export var large = "_5q-3";
export var logoContainer = "_5q-0";
export var nameLogo = "_5q-2";
export var small = "_5q-1";